import request from 'axios';
import store from 'store';
import uniqid from 'uniqid';
import queryString from 'query-string';
import i18n from 'i18n-js';
import {en,zh,bn,ta} from '../data/StaticText';

i18n.translations={en:en,zh:zh,bn:bn,ta:ta};
i18n.locale="en";
i18n.fallbacks=true;

export default class Utilities{

    /************************** Server App Communications *******************************/
    static post(e){
        const csrfToken = store.get("csrfToken");
        request({
            method:"POST",
            url: e.url,
            data:e.data,
            withCredentials: true,
            headers:{
                'csrf-token':csrfToken
            },
            crossDomain:true
        })
        .then((response)=>{
            if(e.success) {
                e.success(response.data);
            }
        })
        .catch((error)=>{
            if(typeof error == "object"){
                if(error.response) {
                    if(error.response.status == 419 || error.response.status == 401){
                        store.set("redirect",window.location.href);
                        this.logout();
                    }
                    if(e.error) {
                        e.error(error.response.data, error.response.status);
                    }
                }
                else{
                    if(e.error) {
                        throw(error);
                        e.error("Unknown Server Error");
                    }
                }
            }
            else{
                if(e.error) {
                    throw (error);
                    e.error(error);
                }
            }
        });
    }

    static async postAsync(e){
        const csrfToken = store.get("csrfToken");
        return request({
            method:"POST",
            url: e.url,
            data:e.data,
            withCredentials: true,
            headers:{
                'csrf-token':csrfToken
            },
            crossDomain:true
        });
    }

    static download(filename,filestamp,success,e,additionalData){
        const modURL = "/api/download-file";
        const csrfToken = store.get("csrfToken");
        let data = {filestamp:filestamp};
        if(additionalData){
            for(var key in additionalData){
                data[key] = additionalData[key];
            }
        }

        request({
            method:"POST",
            url: modURL,
            data:data,
            withCredentials: true,
            crossDomain:true,
            responseType: "blob",
            headers:{
                'csrf-token':csrfToken
            }
        })
        .then(function(response){
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            if(success) {
                success();
            }
        })
        .catch((error) => {
            if(error.response.status == 419){
                this.logout();
            }
            else if(error.response.status == 404){
                e("Error! You have no permission to download this file",404);
            }
            else{
                e("Unknown Server Error", error.response.status);
            }
        });
    }

    /**
     * Convenience function that uses post functions and downloads after successful callback
     *
     * @param {object} e
     *      @var {string} url
     *
     *      @var {object} data
     *
     *      @var {function} success
     *
     *      @var {function} error
     */
    static autoDownload(e){
        this.post({
            url:e.url,
            data:e.data,
            success:(callback)=>{
                this.download(callback.filename,callback.filestamp,e.success,e.error);
            },
            error:e.error,
        });
    }

    /**
     * Uploads a file to the server and gets the filename on the server
     *
     * @param e
     *      @var file
     *
     *      @var filename
     *
     *      @var uploadProgress
     *
     *      @var success
     *
     *      @var error
     *
     * @return {CancelTokenSource|{token, cancel}}
     */
    static upload(e){
        let formData = new FormData();
        formData.append("file", e.file,e.filename);
        if(e.data){
            for(var key in e.data){
                formData.append(key,e.data[key]);
            }
        }

        let CancelToken = request.CancelToken;
        let source = CancelToken.source();

        let modURL = "/upload";

        request.post(
            modURL,
            formData,
            {
              onUploadProgress: e.uploadProgress,
              cancelToken: source.token
            })
            .then((response) => {
                e.success(response.data);
            })
            .catch((error) => {
                console.log(error);
                if(typeof error == "object"){
                    if(error.response) {
                        e.error(error.response.data, error.response.status);
                    }
                    else{
                        e.error("Unknown Server Error");
                    }
                }
                else{
                    e.error(error);
                }
            });

        return source;
    }

    static async uploadAsync(e){
        let formData = new FormData();
        formData.append("file", e.file,e.filename);
        if(e.data){
            for(var key in e.data){
                formData.append(key,e.data[key]);
            }
        }

        let CancelToken = request.CancelToken;
        let source = CancelToken.source();

        let modURL = "/upload";

        return request.post(
            modURL,
            formData,
            {
              onUploadProgress: e.uploadProgress,
              cancelToken: source.token
            });
    }

    static logout(){
        this.post({
            url:"/api/logout",
            data:{},
            success:()=>{
                store.remove("auth");
                store.remove("permissions");
                store.remove("csrfToken");
                this.deleteToken();
                window.location="/login";
            },
            error:(error)=>{
                store.remove("auth");
                store.remove("permissions");
                store.remove("csrfToken");
                this.deleteToken();
                window.location="/login";
            }
        });
    }

    static removeStore(){
        //Clears user store, happens when fake token parsed OR user select NOT ME
        store.each(function(value,key){
            store.remove(key);
        });
    }

    static deleteToken(){
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
    }

    static processError(e){
        const response = e.response;
        if(!response){
            console.log(e);
            return {
                error:"Unknown Server Error",
            }
        }
        else{
            return {
                error:response.data,
                status:response.status,
            }
        }
    }

    /***************************** Store Information **************************************/
    static getUserID(){
        return store.get("staffID");
    }

    static getUserEmail(){
        return store.get("email");
    }

    static getFullName(){
        return store.get("staffName")
    }

    static getUserEmail(){
        return store.get("email");
    }

    static getUserAvatar(){
        return store.get("avatarLink");
    }

    static getAvatarLink(link){
        if(link){
            return link;
        }
        else{
            return "/images/app/default-user.png";
        }
    }

    static getTenantID(){
        return store.get("tenantID");
    }

    static getTenantName(){
        return store.get("tenantName");
    }

    static getTurnstileToken(){
        return store.get("token");
    }

    static getTokenTime(){
        return store.get("tokenTime");
    }

    static getFavorite(){
        return store.get("favorite");
    }

    static getPermissions(key){
        const allPermissions = store.get("permissions");
        if(key == "none"){
            return {view:2};
        }
        if(allPermissions) {
            if (allPermissions[key]) {
                return allPermissions[key];
            }
        }
        return 0;
    }

    static getAllPermissions(){
        let allPermission = store.get("permissions");
        allPermission = (allPermission) ? allPermission : {};
        allPermission["none"]={view:2};

        return allPermission;
    }

    static getSettings(module,moduleName){
        const allSettings = store.get("settings");
        if(allSettings[module]){
            return allSettings[module][moduleName];
        }

        if(module == "tagSettings"){
            return [];
        }

        return undefined;
    }

    static getListSettings(listname){
        const tagMacros = store.get("tagMacros");
        const tagSuggest = store.get("tagSuggest");
        const columnSettings = store.get("columnSettings");
        const pageLength = store.get(listname+"-page-length");

        let cs = (columnSettings[listname]) ? columnSettings[listname] : [];

        cs.sort((a,b)=>{
            if(a.position-b.position == 0){
                if(a.name < b.name)
                    return -1;
                else if(a.name > b.name){
                    return 1;
                }
                return 0;
            }
            return a.position-b.position;
        });

        return {
            tagMacros:(tagMacros[listname]) ? tagMacros[listname] : [] ,
            tagSuggest:(tagSuggest[listname]) ? tagSuggest[listname] : [],
            columnSettings:cs,
            pageLength: pageLength,
        }
    }

    static getTagMacros(listname){
        const macros = store.get("tagMacros");
        return macros[listname];
    }

    static getKey(){
        return uniqid();
    }

    static getSuperUser(){
        return store.get("isManagement");
    }

    static getTagSuggest(listLabel){
        const allSuggest = store.get("tagSuggest");
        if(allSuggest[listLabel]){
            return allSuggest[listLabel];
        }
        return [];
    }

    static getBulkEdit(listLabel){
        const bulkEdit = store.get("bulkEdit");
        if(bulkEdit[listLabel]){
            return bulkEdit[listLabel];
        }
        return [];
    }

    static getEzSpreadsheetOptions(listLabel){
        const spreadsheetOptions = store.get("ezspreadsheets");
        if(spreadsheetOptions[listLabel]){
            return spreadsheetOptions[listLabel];
        }
        return [];
    }

    static getEzSpreadsheetMacros(listLabel){
        const ezspreadsheetsMacros = store.get("ezspreadsheetsMacros");
        if(ezspreadsheetsMacros[listLabel]){
            return ezspreadsheetsMacros[listLabel];
        }
        return [];
    }

    static getSearchListItem(listLabel){
        const listItems = store.get("listItems");
        if(listItems[listLabel]){
            return listItems[listLabel];
        }
        return [];
    }

    static getClientAvatar(){
        return "https://repo.smart-dorm.com/media/general/avatar/client.png";
    }

    static linkReplace(link,content){
        while(link.indexOf("%(") != -1){
            const start = link.indexOf("%(");
            const end = link.indexOf(")%");
            const contentField = link.substring(start + 2, end);
            link = link.replace("%(" + contentField + ")%" , content[contentField]);
        }
        return link;
    }

    /****************************** Static Methods ***************************************/

    static isMobileDevice(){
        var check = false;
        if(typeof navigator == "undefined"){
            return false;
        }
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        //(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    }

    static isiOS() {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }

    /**
     * Sets context of a link into local storage
     *
     * @param {string} e.currentTarget.id
     *  For Profile Pages  id = profileID-{id}
     *  I.E. for staff page use id = staffID-s_0001
     *
     *  For List Pages id = listNamelist-tag1~tag2~tag3
     *  I.E. for Maintenance List = maintenancelist-clearanceID(c_000)~clientID(C_000)
     */
    static setLinkContext(e){
        if(e.currentTarget.id.indexOf("-") != -1) {
            const kvp = e.currentTarget.id.split("-");
            store.set(kvp[0], kvp[1]);
        }
    }

    static getLabelFromValue(value,options){
        if(typeof options == "undefined"){
            return "";
        }
        for(var i=0; i<options.length; i++){
            if(options[i].value == value){
                return options[i].label;
            }
        }
        return "";
    }

    static getIndexFromValue(value,options){
        if(typeof options == "undefined" || options.length == 0){
            return "";
        }
        for(var i=0; i<options.length; i++){
            if(options[i].value == value){
                return i;
            }
        }
        return -1;
    }

    static deepCloneArray(settings){
        let array = [];
        for (var i=0; i<settings.length; i++){
            array.push(Object.assign({},settings[i]));
        }
        return array;
    }

    static arrayMove(arr, old_index, new_index) {
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
};

    static mapArrayToDivisions(arrayLength){
        const divisions = (arrayLength >= 12) ? 3 : ((arrayLength >= 6) ? 2 : 1);
        const divisionLength = Math.floor(arrayLength / divisions);
        const divisionAdd = arrayLength % divisions;
        let divisionMap = [];


        let divisionSize = [];
        for(var i=0; i<divisions; i++){
            divisionSize.push(divisionLength);
        }

        let counter = 0;
        for(var j=0; j<divisionAdd; j++){
            divisionSize[j] ++;
            counter ++;
            if(counter > divisionSize.length){
                counter = 0;
            }
        }

        let end = 0;
        for(var n=0; n<divisionSize.length; n++){
            const start = (n-1 >= 0) ? end : 0;
            end = start + divisionSize[n];
            divisionMap.push({start:start,end:end});
        }


        return divisionMap;
    }

    static capitalize(value,firstOnly){
        if(typeof value != "string"){
            return undefined;
        }

        let capitalizedValue = value;
        capitalizedValue = capitalizedValue.toLowerCase();
        capitalizedValue = capitalizedValue.substr(0, 1).toUpperCase() + capitalizedValue.substr(1);

        if(firstOnly){
            return capitalizedValue;
        }

        for(var i=1; i<capitalizedValue.length; i++){
            if(capitalizedValue[i-1] == " "){
                capitalizedValue = capitalizedValue.substr(0, i)+ capitalizedValue.substr(i, 1).toUpperCase() + capitalizedValue.substr(i+1);
            }
        }
        return capitalizedValue;
    }

    static timeWithin(time,start,end){
        let s = start.split(":");
        let e = end.split(":");
        let now = time.split(":");

        let gs = false;
        let se = false;

        //Change start from 24:00 to 00:00
        if(s[0] == "24"){
            s[0] = "00";
        }
        //Change end from 00:00 to 24:00
        if(e[0] == "00"){
            e[0] = "24";
        }

        if(parseInt(now[0]) > parseInt(s[0])){
            gs = true;
        }
        else if(parseInt(now[0]) == parseInt(s[0])){
            if(parseInt(now[1]) >= parseInt(s[1])){
                gs = true;
            }
        }

        if(parseInt(now[0]) < parseInt(e[0])){
            se = true;
        }
        else if(parseInt(now[0]) == parseInt(e[0])){
            if(parseInt(now[1]) < parseInt(e[1])){
                se = true;
            }
        }

        return (se && gs);
    }

    static notNull(value){
        if(typeof value == "object"){
            if(value == null){
                return false;
            }
            else {
                return (value.length > 0);
            }
        }

        return (typeof value != "undefined" && value != null);
    }

    static isNull(value){
        return (typeof value == "undefined" || value == null);
    }

    static integerShorten(value){
        let val = parseFloat(value);
        let skips = 0;
        while(val > 1000.0){
            val = val/1000.0;
            skips++;
        }

        const skipText=[
            "",
            "k",
            "m",
            "b"
        ];

        return ((val > 10.0) ? Math.round(val) : val.toFixed(1)) + skipText[skips];
    }

    static integerComma(x){
        if(x == null || typeof x == "undefined"){
            return "";
        }
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    static scrollPage(y){
        document.querySelector(".app-container").scrollTop=0;
    }

    static hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
            hex:hex
        } : null;
    }

    static integerToCommaText(x){
        if(x == null || typeof x == "undefined"){
            return "";
        }
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    static getQuery(props,key){
        const query = queryString.parse(props.location.search);
        return query[key];
    }

    static convertTimeToLinear(time){
        //time = HH:mm
        const HH = time.substr(0,2);
        const mm = time.substr(3,2);
        return parseFloat(HH) + parseFloat(mm)/60.0;
    }

    static convertLinearToTime(linear){
        const mm = Math.round((((linear * 100) - (Math.floor(linear) * 100)) / 100.0) * 60);
        let HH = Math.floor(linear);
        return ((HH < 10) ? "0" + HH : HH) + ":" + ((mm < 10) ? "0" + mm : mm);
    }

    static onPlayStore(){

    }

    static onAppStore(){

    }

    static getDateArray(daysInMonth,addEmpty){
        let dateArray=[];
        for(var d=1; d<=daysInMonth; d++){
            dateArray.push(((d<10) ? "0" + d : "" + d));
        }

        if(addEmpty){
            dateArray.unshift("NA");
        }
        return dateArray;
    }

    static tx(key){
        return i18n.t(key);
    }

    static txLocale(key){
        i18n.locale = key;
    }

    static getDowLabel(value){
        if(typeof value == "undefined" || value == null || value.length != 7 || value.filter((item)=>{return item == 1}).length == 0){
            return (this.props.rules.nullText) ? this.props.rules.nullText : "None";
        }
        const labelText=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
        let dow = "";
        for(var i=0; i<value.length; i++){
            if(value[i]){
                dow += ((dow.length > 0) ? " / " : "") + labelText[i];
            }
        }
        return dow;
    }
}
